import image191100MmaLandscape from './image-191-100-mma-landscape';
import image11MmaSquare from './image-1-1-mma-square';
import image41MmaWide from './image-4-1-mma-wide';
import image12MmaVertical from './image-1-2-mma-vertical';

export const searchImageAdTemplates = [
  image41MmaWide,
  image191100MmaLandscape,
  image11MmaSquare,
  image12MmaVertical,
];
